import { Box, BoxProps } from '@mui/material';

import { withSxProp } from 'common/utils/props';

export const CardButtonIcon = ({ children, sx, ...props }: BoxProps) => (
    <Box
        sx={[
            {
                boxShadow: 'none',
                backgroundColor: 'common.white',
                border: '1px solid',
                borderColor: 'divider',
                width: '45px',
                height: '45px',
                borderRadius: '50%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                color: 'inherit',
            },
            ...withSxProp(sx),
        ]}
        {...props}
    >
        {children}
    </Box>
);

export const CardButton = ({ children, sx, ...props }: BoxProps) => (
    <Box
        sx={[
            {
                backgroundColor: 'grey.100',
                borderRadius: 1,
                height: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                cursor: 'pointer',
                border: '1px solid transparent',
                transition: '300ms border-color',
                flexDirection: 'column',
                textAlign: 'center',
                fontSize: 'body2.fontSize',
                lineHeight: 1.2,
                '&:hover': {
                    borderColor: 'divider',
                },
            },
            ...withSxProp(sx),
        ]}
        {...props}
    >
        {children}
    </Box>
);
